import React, { ReactNode } from 'react';
import styles from '../styles.module.css';

export default function SideBarCard({
  children,
  title,
  subTitle,
  icon,
}: {
  children?: ReactNode;
  title?: string;
  subTitle?: string;
  icon?: ReactNode;
}) {
  return (
    <div className={`${styles.card}`}>
      {title && (
        <h5 className={`${!subTitle && styles.bottomMargin}`}>
          <span className={`${styles.ico}`}>{icon}</span>
          <span>{title}</span>
        </h5>
      )}
      {subTitle && <div className={`${styles.sub} ${styles.bottomMargin}`}>/ {subTitle}</div>}
      <div className={`${styles.items}`}>{children}</div>
    </div>
  );
}
